import axios from 'axios'

export default {
    namespaced: true,

    state: {
        authenticated: false,
        user: {student_id: null, student_name: null},
        studentRecord: null,
        overlay: false,
        dialog: false,
        loginErrors: '', 
    },

    getters: {
        getAuthenticated (state) {
            return state.authenticated
        },

        getUser (state) {
            return state.user
        },

        getUserId (state) {
            return state.user.student_id
        },

        getOverlay(state){
            return state.overlay
        },

        getStudentRecord(state){
            return state.studentRecord
        },

        getDialog(state){
            return state.dialog
        },

        getLoginErrors(state){
            return state.loginErrors
        }
    },

    mutations: {
        setAuthenticated (state, value) {
            state.authenticated = value
        },

        setUser (state, value) {
            state.user = value
        },

        setOverlay (state, value){
            state.overlay = value
        },

        setStudentRecord(state, value){
            state.studentRecord = value
        },

        setDialog(state, value){
            state.dialog = value
        },

        setLoginErrors(state, value){
            state.loginErrors = value
        }
    },

    actions: {
        async signIn ({dispatch, commit}, credentials){            
            commit('setOverlay', true);
            await axios.get('/sanctum/csrf-cookie')
                
            await axios.post('/login', credentials)
                    .then(() => {                       
                        commit('setAuthenticated', true);                        
                    })
                    .catch(err => {
                        console.log(err);
                        commit('setLoginErrors', err);
                        commit('setAuthenticated', false)
                        //return state.getAuthenticated                        
                    })            
                
            return dispatch('user', credentials)
        },

        async user({ commit, getters}, credentials){
            //commit('setAuthenticated', true);
            commit('setUser', credentials);
            let url = '/api/student-record/' + getters.getUserId;
            console.log(`url: ${url}`);
            return axios.get(url)
                .then(response => {
                    console.log(response);
                    //commit('setAuthenticated', true)
                    commit('setStudentRecord', response.data[0])
                    commit('setOverlay', false);
                    console.log(`Action user Authenticated: ${getters.getAuthenticated}`)
                })
                .catch(error => {
                    //commit('setAuthenticated', false)
                    commit('setUser', null)
                    console.log(error)
                })
                
        },

        async signOut({commit}){                       
            await axios.post('/logout')
                    .then(response => {
                        console.log(response);
                    })
            return commit('setAuthenticated', false); 
        },
        
        async saveRecord({getters}){
            //console.log(getters.getStudentRecord);
            return axios.post('/api/student', getters.getStudentRecord);
        },

       checkSession({dispatch}){           
           console.log(`Cookie Set: ${dispatch('cookieSet', 'ans_api_session')}`);
       },

       async getStudents(){
           return await axios.get('/api/students')
       },

       cookieSet(cookieName){
           let name = cookieName + "=";
           let decodedCookie = decodeURIComponent(document.cookie);
           let cookies = decodedCookie.split(';');
           for(var i = 0; i < cookies.length; i++){
               var c = cookies[i];
               while(c.charAt(0) == ' '){
                   c = c.substring(1);
               }
               if(c.indexOf(name) == 0){
                    return true;
               }
           }
           return false;
       }
    }
}